module.exports = __webpack_public_path__ + "static/media/gitlabLogo.34c1929a.svg";